import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '@shared/stores/AuthContext'
import type { UserRole } from '@shared/interfaces/appInterface'

export default function ProtectedRoute({
    roles,
    children
}: {
    roles?: UserRole[]
    children: ReactNode
}) {
    const { user, bootstrapping } = useAuth()
    const location = useLocation()

    if (bootstrapping) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[var(--color-paper)]">
                <div className="text-sm uppercase tracking-[0.22em] text-[var(--color-navy-500)]">Loading…</div>
            </div>
        )
    }

    if (!user) {
        const redirect = encodeURIComponent(location.pathname + location.search)
        return <Navigate to={`/dashboard/login?redirect=${redirect}`} state={{ from: location.pathname }} replace />
    }

    const effectiveRole: UserRole = user.role === 'editor' ? 'admin' : user.role
    if (roles && !roles.includes(user.role) && !roles.includes(effectiveRole)) {
        return <Navigate to="/dashboard" replace />
    }
    return <>{children}</>
}
